import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AVAILABLE_NOTE_TEMPLATES } from './constants/available-note-templates';
import { EVENT_FLOW_FIELD_LABELS } from '../../node-parameters/constants/event-flow-field-labels.const';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { NgFor } from '@angular/common';
import { MatTextareaInputComponent } from '../../../../editors/mat-textarea-input/mat-textarea-input.component';

@Component({
    selector: 'app-hha-note-template',
    templateUrl: './hha-note-template.component.html',
    styleUrls: ['./hha-note-template.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatIconButton,
        MatTooltip,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        NgFor,
        MatMenuItem,
        MatTextareaInputComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class HhaNoteTemplateComponent {
  @Input({ required: true })
  noteFormControl!: FormControl;

  public readonly availableNoteTemplates = AVAILABLE_NOTE_TEMPLATES;
  public readonly fieldLabels = EVENT_FLOW_FIELD_LABELS;

  public onTemplateSelect(template: string): void {
    this.noteFormControl.patchValue(template);
  }
}
